var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"menu h-100"},[_c('nav',[_c('ul',_vm._l((_vm.tabs),function(tab){return _c('li',{key:tab,class:{ active: _vm.currentTab === tab },on:{"click":function($event){return _vm.onClickSwitchTab(tab)}}},[_vm._v(" "+_vm._s(_vm.$t(tab))+" ")])}),0)]),_c(_vm.currentTabComponent,{tag:"component",staticClass:"tab-content h-100"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }